import { Icon, IconVariants } from 'core/generic/elements/icons';

import styles from './form-header.module.scss';

type FormHeaderProps = {
	headerTitle: string;
	iconVariant?: IconVariants;
};

export const FormHeader = ({ headerTitle, iconVariant }: FormHeaderProps) => {
	return (
		<div className={`${styles.headerWrapper}`}>
			<h1 className={`${styles.headerTitle} display-medium bold`}>
				{iconVariant && <Icon variant={iconVariant} />}
				{headerTitle}
			</h1>
		</div>
	);
};

export default FormHeader;
